import type { ReactNode } from 'react';

import type { SchemaOpenClaimsEntry } from '~/features/leadDetails/schemas/demandedDocuments.schema';
import { dateFormat } from '~/lib/i18n';

type Props = {
    action: ReactNode;
    claims: SchemaOpenClaimsEntry[];
    title?: string;
    'data-testid'?: string;
};

export const OpenClaimsGroup: React.FC<Props> = ({ action, claims, title, ...props }) => (
    <div className="flex flex-col gap-6 p-4 rounded-md bg-surface-light" data-testid={props['data-testid']}>
        {title && <p className="pl-[5px] text-base font-medium text-midnight">{title}</p>}
        <div className="flex flex-wrap items-center gap-x-[3px] gap-y-1.5">
            {claims.map(({ attribution, demandedDate, name }) => (
                <span
                    key={`${name}-${attribution}`}
                    className="inline-flex h-6 items-center px-2.5 text-sm font-medium bg-white border rounded-full border-grey-outline-light text-midnight"
                >
                    {demandedDate ? `${name} (${dateFormat(demandedDate)})` : name}
                </span>
            ))}
            <div className="ml-auto">{action}</div>
        </div>
    </div>
);
